import { faFile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Zoom from 'react-medium-image-zoom';
import { MessagingFile } from '../../../../../interfaces/interfaces';
import { createDisplayLink } from '../../../../../services/helper';
import Link from 'next/link';
export const MessageFiles = ({ files, pending }: { files?: MessagingFile[]; pending: boolean }) => {
  if (!(files && files.length > 0 && !pending)) return <></>;
  return (
    <>
      {files.map((f) =>
        f.file_type?.includes('image') ? (
          <Zoom>
            <img src={createDisplayLink(f._id)} height="auto" />
          </Zoom>
        ) : (
          <Link
            className="grid place-items-center p-16 w-full bg-opacity-20 transition-all cursor-pointer cursor-pointetr bg-slate-400 hover:bg-opacity-25"
            href={createDisplayLink(f._id)}
            target="_blank">
            <FontAwesomeIcon icon={faFile} />
          </Link>
        )
      )}
    </>
  );
};
